import React from "react";

interface PanelContainerProps {
    children?: any;
    spacing?: number;
}

class PanelContainer extends React.Component<PanelContainerProps> {
    render(): React.ReactNode {
        return (
            <div
                className="panel-container"
                style={{ gap: this.props.spacing ?? 20 }}>
                {this.props.children}
            </div>
        );
    }
}

export default PanelContainer;
